export const UNIT_OPTIONS = <const> {
	to: { symbol: 't', label: 'unit.to' },
	pc: { symbol: 'pcs', label: 'unit.pc' },
	kg: { symbol: 'kg', label: 'unit.kg' }
};

export const UNIT_OPTIONS_KEYS = <const> ['to', 'pc', 'kg'];

export const DEFECT_OPTIONS = <const> {
	CDCUS00A: { label: 'defect.CDCUS00A', sample: false },
	CDCUS00C: { label: 'defect.CDCUS00C', sample: true },
	CDCUS00D: { label: 'defect.CDCUS00D', sample: true },
	CDCUS00E: { label: 'defect.CDCUS00E', sample: false },
	CDCUS00F: { label: 'defect.CDCUS00F', sample: true },
	CDCUS00G: { label: 'defect.CDCUS00G', sample: false },
	CDCUS00H: { label: 'defect.CDCUS00H', sample: true },
	CDCUS00I: { label: 'defect.CDCUS00I', sample: false },
	CDCUS00J: { label: 'defect.CDCUS00J', sample: false },
	CDCUS00M: { label: 'defect.CDCUS00M', sample: false },
	CDCUS00B: { label: 'defect.CDCUS00B', sample: false },
	CDCUS00L: { label: 'defect.CDCUS00L', sample: false },
	CDCUS00K: { label: 'defect.CDCUS00K', sample: false }
};

export const DEFECT_DETAILED_OPTIONS = <const> {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00A/0600': { label: 'defect.Z/CDCUS00A/0600', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00C/0400': { label: 'defect.Z/CDCUS00C/0400', sample: true },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00C/1400': { label: 'defect.Z/CDCUS00C/1400', sample: true },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00D/0500': { label: 'defect.Z/CDCUS00D/0500', sample: true },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00E/0400': { label: 'defect.Z/CDCUS00E/0400', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00F/0400': { label: 'defect.Z/CDCUS00F/0400', sample: true },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00G/0700': { label: 'defect.Z/CDCUS00G/0700', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00H/0600': { label: 'defect.Z/CDCUS00H/0600', sample: true },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00I/0600': { label: 'defect.Z/CDCUS00I/0600', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00J/0900': { label: 'defect.Z/CDCUS00J/0900', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00M/0300': { label: 'defect.Z/CDCUS00M/0300', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00B/0100': { label: 'defect.Z/CDCUS00B/0100', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00B/0200': { label: 'defect.Z/CDCUS00B/0200', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00L/0100': { label: 'defect.Z/CDCUS00L/0100', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00L/0600': { label: 'defect.Z/CDCUS00L/0600', sample: false },
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'Z/CDCUS00K/0300': { label: 'defect.Z/CDCUS00K/0300', sample: false },
};

export const DEFECT_DETAILED_OPTIONS_KEYS = <const> [
	'Z/CDCUS00A/0600',
	'Z/CDCUS00C/0400',
	'Z/CDCUS00C/1400',
	'Z/CDCUS00D/0500',
	'Z/CDCUS00E/0400',
	'Z/CDCUS00F/0400',
	'Z/CDCUS00G/0700',
	'Z/CDCUS00H/0600',
	'Z/CDCUS00I/0600',
	'Z/CDCUS00J/0900',
	'Z/CDCUS00M/0300',
	'Z/CDCUS00B/0100',
	'Z/CDCUS00B/0200',
	'Z/CDCUS00L/0100',
	'Z/CDCUS00L/0600',
	'Z/CDCUS00K/0300',
];

export const CORROSION_OPTIONS = <const> {
	A: { label: 'corrosion.A' },
	S: { label: 'corrosion.S' },

};
export const CORROSION_OPTIONS_KEYS = <const> [
	'A',
	'S'

];
export const LATITUDE_OPTIONS = <const> {
	S: { label: 'latitude.S' },
	N: { label: 'latitude.N' },

};
export const LATITUDE_OPTIONS_KEYS = <const> [
	'S',
	'N'

];
export const LONGITUDE_OPTIONS = <const> {
	E: { label: 'longitude.E' },
	W: { label: 'longitude.W' },

};
export const LONGITUDE_OPTIONS_KEYS = <const> [
	'E',
	'W'

];
export const EPASSIVE_OPTIONS = <const> {
	P: { label: 'epassivefilm.P' },
	S: { label: 'epassivefilm.S' },
};
export const EPASSIVE_OPTIONS_KEYS = <const> [
	'P',
	'S'
];
export const FABRICATION_OPTIONS = <const> {
	R: { label: 'fabrication.process.R' },
	S: { label: 'fabrication.process.S' },
	H: { label: 'fabrication.process.H' },
	L: { label: 'fabrication.process.L' }

};
export const FABRICATION_OPTIONS_KEYS = <const> [
	'R',
	'S',
	'H',
	'L',

];

export const CURRENCY_OPTIONS = <const> {
	usd: 'DOL',
	sek: 'SEK',
	ron: 'RON',
	pln: 'PLN',
	gbp: 'GBP',
	eur: 'EUR',
	czk: 'CZK'
};

export const CURRENCY_OPTIONS_KEYS = <const> [
	'usd',
	'sek',
	'ron',
	'pln',
	'gbp',
	'eur',
	'czk'
];

export const LANGUAGE_OPTIONS = <const> {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	it: 'Italiano',
	de: 'Deutsch',
	pl: 'Polski'
};

export const LANGUAGE_OPTIONS_KEYS = <const> [
	'en',
	'es',
	'fr',
	'it',
	'de',
	'pl'
];

export const LANGUAGE_REGION_OPTIONS = <const> {
	en: 'en-GB',
	es: 'es-ES',
	fr: 'fr-FR',
	it: 'it-IT',
	de: 'de-DE',
	pl: 'pl-PL'
};

export const LANGUAGE_CODE_OPTIONS = <const> {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'en-GB': 'English',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'es-ES': 'Español',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'fr-FR': 'Français',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'it-IT': 'Italiano',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'de-DE': 'Deutsch',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'pl-PL': 'Polski',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'ru-RU': 'Russian',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'nl-NL': 'Dutch'
};

export const ORDER_NUMBER_OPTIONS = <const> {
	customer: 'settings.order.customer',
	supplier: 'settings.order.supplier'
};

export const PRODUCT_OPTIONS = <const> {
	article: 'settings.product.article',
	steelgrade: 'settings.product.steelgrade'
};

export const WEIGHT_OPTIONS = <const> {
	gross: 'settings.weight.gross',
	net: 'settings.weight.net'
};

export const DOWNLOAD_OPTIONS = <const> {
	aggregated: 'settings.download.aggregated',
	duplicate: 'settings.download.duplicate'
};

export const DOWNLOAD_OPTIONS_KEYS = <const> [
	'aggregated',
	'duplicate'
];

export const ORDER_TRACKING_LIST_SORT = <const> {
	cdd_desc: 'sortby.cdd.desc',
	cdd_asc: 'sortby.cdd.asc',
	order_asc: 'sortby.order.asc',
	order_desc: 'sortby.order.desc',
	product_asc: 'sortby.product.asc',
	product_desc: 'sortby.product.desc',
};

// Constant for Service name in APPINSIGHTS
export const SERVICE_ANALYTICS = <const> {
	COMMON: 'common',
	SEARCH: 'search',
	WOT: 'wot',
	DOC: 'doc',
	GUARANTEE: 'guarantee-requests',
	CLAIM: 'quality-issue',
	MT: 'material-tracking',
	EOFFER: 'eoffer',
	PRODUCT: 'product',
	USER: 'user',
	NOTFOUND: 'notfound', // for 404 error tracking
	NEED4STEEL: 'ND4ST',
	FASTLANE: 'fastlane',
	EORDER: 'EORDR',
	AUCTION: 'auction',
	ORDER_TRACKING: 'order-tracking',
	SALES: 'sales',
	QUALITY: 'quality',
	ECALL_OFF: 'ecall-off',
	ECALL_OFF_VOLUME: 'ecall-off-volume',
	ECALL_OFF_BATCH: 'ecall-off-batch',
	COMMERCIAL_DOCUMENTS: 'commercial-documents',
	INVOICE: 'INVOICE',
	ORDER_ACKNOWLEDGMENT: 'order-acknowledgment',
	CERTIFICATE: 'certification',
	DISPATCH_ADVICE: 'dispatch-advice',
	QUALITY_ISSUE: 'quality-issue',
	NEED_FOR_STEEL: 'need-for-steel',
	WEB_ORDER_ENTRY: 'web-order-entry',
	COIL_CALCULATOR: 'coil-calculator',
	ORDER_SPOT: 'order-spot',
	ORDER_SCHEDULE: 'order-schedule',
	BATCH: 'batch',
	SHIPMENT: 'shipment',
	ORGANIZATIONS: 'organizations',
	AQDB: 'aqdb',
	EFEASIBILITY: 'efeasibility',
	XCARB: 'xcarb',
};

export const SURVEY_SCREEN_NAME_OPTIONS = <const> {
	orderdeliveryoverview: 'settings.survey.wot.overview',
};
